/**
 * Stored values held to six decimal places. A JavaScript engine is free to
 * differ in the last bit of `Math.sin`, `Math.acos` and `Math.exp`, and a
 * stored value reaches the fingerprint and the save; rounding keeps such a
 * difference out of both unless it lands on a rounding boundary. Six places is
 * under four milliseconds of day length and a millionth of a degree, far finer
 * than anything reads it.
 */
export function held(value: number): number {
  return Math.round(value * 1e6) / 1e6;
}
